import React from "react";
import AppLayout from "@/components/AppLayout";
import { Card } from "@/components/ui/card";
import { Music2, Search, FileText, Handshake } from "lucide-react";

const STEPS = [
  { icon: Music2, t: "1. Create your profile", d: "Sign in, pick your identity — Musician, Band, DJ or Venue / Event Organizer — and upload a profile picture. You can add more profiles anytime." },
  { icon: Search, t: "2. Explore opportunities or talent", d: "One page for everything. Filter by city, genre and rate. See real gigs from venues and event organizers, and browse working musicians, bands and DJs." },
  { icon: FileText, t: "3. Apply / receive applications", d: "Send a structured application to any gig, or manage requests received on your posts. Everything shows up under Applications." },
  { icon: Handshake, t: "4. Get accepted and connect directly", d: "The moment the poster accepts, contact details unlock for both parties. Continue on WhatsApp — no chat inbox, no back-and-forth in-app." },
];

export default function HowItWorks() {
  return (
    <AppLayout>
      <h1 className="font-display text-3xl font-bold tracking-tight">How Showfex works</h1>
      <p className="mt-2 text-slate-600 max-w-2xl">A clean marketplace for real music bookings. No feeds, no likes — just gigs, applications and confirmed connections.</p>
      <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-4">
        {STEPS.map((s, i) => (
          <Card key={i} className="p-6 border-slate-200">
            <s.icon className="w-6 h-6 text-[#4F46E5]" />
            <div className="mt-3 font-semibold text-slate-900">{s.t}</div>
            <p className="mt-1 text-sm text-slate-600 leading-relaxed">{s.d}</p>
          </Card>
        ))}
      </div>
    </AppLayout>
  );
}
